import Backbone from "backbone";
import _ from "underscore";
import "handlebarsHelpers";
import "jqueryUI";
import "jqueryWidget";
import "ajaxQ/ajaxq";
const $ = Backbone.$;

$.capitalizeFirstLetter = function (str) {
    str = str.replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
    });
    return str;
};
//CUSTOM Function to get browser and version.
$.get_browser = function (options) {
    var ua = navigator.userAgent,
        tem,
        iOS = false,
        M = ua.match(/(opera|chrome|crios|fxios|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {name: 'IE', version: (tem[1] || '')};
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/);
        if (tem != null) {
            return {name: 'Opera', version: tem[1]};
        }
    } else if (M[1] === 'CriOS') {
        M[1] = 'Chrome';
        iOS = true;
    } else if (M[1] === 'FxiOS') {
        M[1] = 'Firefox';
        iOS = true;
    } else {
        iOS = new RegExp(/iPad|iPhone|iPod/i).test(ua);
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    return {
        name: M[0],
        version: M[1],
        ios: iOS
    };
};

$.supportsAjaxQ = function () {
    return !$.get_browser().ios;
};
$.clearHtmlScripts = function clearHtmlScripts(htmldoc) {
    const html5UrlAttrs = [
        "action",
        "cite",
        "data",
        "enctype",
        "formaction",
        "formenctype",
        "href",
        "manifest",
        "poster",
        "src"
    ];

    const html5Events = [
        "onabort",
        "onafterprint",
        "onbeforeprint",
        "onbeforeunload",
        "onblur",
        "oncancel",
        "oncanplay",
        "oncanplaythrough",
        "onchange",
        "onclick",
        "oncuechange",
        "ondblclick",
        "ondurationchange",
        "onemptied",
        "onended",
        "onerror",
        "onfocus",
        "onhashchange",
        "oninput",
        "oninvalid",
        "onkeydown",
        "onkeypress",
        "onkeyup",
        "onload",
        "onloadeddata",
        "onloadedmetadata",
        "onloadstart",
        "onmessage",
        "onmousedown",
        "onmouseenter",
        "onmouseleave",
        "onmousemove",
        "onmouseout",
        "onmouseover",
        "onmouseup",
        "onmousewheel",
        "onoffline",
        "ononline",
        "onpagehide",
        "onpageshow",
        "onpause",
        "onplay",
        "onplaying",
        "onpopstate",
        "onprogress",
        "onratechange",
        "onreset",
        "onresize",
        "onscroll",
        "onseeked",
        "onseeking",
        "onselect",
        "onshow",
        "onstalled",
        "onstorage",
        "onsubmit",
        "onsuspend",
        "ontimeupdate",
        "ontoggle",
        "onunload",
        "onvolumechange",
        "onwaiting"
    ];
    const documentNode = document.createElement("html");
    documentNode.innerHTML = htmldoc;
    const $xmlDom = $(documentNode);
    $xmlDom.find('script').remove();
    html5UrlAttrs.forEach(attr =>
        $xmlDom.find(`[${attr}]`)
            .filter((i, el) => $(el).attr(attr).includes("javascript:"))
            .removeAttr(attr)
    );
    html5Events.forEach(attr => $xmlDom.find(`[${attr}]`).removeAttr(attr));
    return documentNode.outerHTML;
};
if ($.supportsAjaxQ()) {
    var methodMap = {
        'create': 'POST',
        'update': 'PUT',
        'delete': 'DELETE',
        'read': 'GET'
    };
    var getValue = function (object, prop) {
        if (!(object && object[prop])) return null;
        return _.isFunction(object[prop]) ? object[prop]() : object[prop];
    };
    /******** BACKBONE AJAX OVERRIDE **********/
    Backbone.sync = function (method, model, options) {
        var type = methodMap[method];

        // Default options, unless specified.
        options || (options = {});

        // Default JSON-request options.
        var params = {type: type, dataType: 'json'};

        // Ensure that we have a URL.
        if (!options.url) {
            params.url = getValue(model, 'url') || function() {
                throw new Error('A "url" property or function must be specified');
            }();
        }

        // Ensure that we have the appropriate request data.
        if (!options.data && model && (method == 'create' || method == 'update')) {
            params.contentType = 'application/json';
            params.data = JSON.stringify(model.toJSON());
        }

        // For older servers, emulate JSON by encoding the request into an HTML-form.
        if (Backbone.emulateJSON) {
            params.contentType = 'application/x-www-form-urlencoded';
            params.data = params.data ? {model: params.data} : {};
        }

        // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
        // And an `X-HTTP-Method-Override` header.
        if (Backbone.emulateHTTP) {
            if (type === 'PUT' || type === 'DELETE') {
                if (Backbone.emulateJSON) params.data._method = type;
                params.type = 'POST';
                params.beforeSend = function (xhr) {
                    xhr.setRequestHeader('X-HTTP-Method-Override', type);
                };
            }
        }

        // Don't process data on a non-GET request.
        if (params.type !== 'GET' && !Backbone.emulateJSON) {
            params.processData = false;
        }

        // Make the request, allowing the user to override any Ajax options.
        return $.ajaxDefaultQ(_.extend(params, options));
    };
    /******** /BACKBONE AJAX OVERRIDE *********/
}

export {Backbone as default, Backbone, _, $};